import BillableFilters from "./filters";
import CreateItemButton from "components/buttons/create";
import List from "components/list";
import React from "react";
import { useJob } from "@/modules/work/jobs/context";
import { useParams } from "react-router-dom";
import BillableName from "@/components/billable/cells/name";
import { DateCell } from "@/components/date/cell";
import { StatusCell } from "@/components/status/cell";
import TypeCell from "@/components/type/cell";
import { AmountCell } from "@/components/cells/amount";
import { PermissionGate } from "permissions/components/gate";
import HeaderPortal from "components/portal/header-portal";
import { usePermissions } from "contexts/permission";

export default function JobBillables() {
  const { jobId } = useParams();
  const { config, type } = useJob();
  const permissions = usePermissions();

  const baseFields = [
    "id",
    "name",
    "type",
    "job.name",
    "status",
    "billing_date",
    "due_date",
  ];

  const canReadAmount = permissions.hasFieldAccess(
    "billables",
    "read",
    "amount",
  );

  const fields = [
    ...baseFields,
    ...(canReadAmount ? ["amount", "currency.name", "adjusted_amount"] : []),
  ];

  const columns = [
    {
      id: "name",
      header: "Name",
      accessorKey: "name",
      cell: BillableName,
    },
    {
      id: "status",
      header: "Status",
      accessorKey: "status",
      cell: StatusCell,
    },
    {
      id: "type",
      header: "Type",
      accessorKey: "type",
      cell: TypeCell,
    },
    {
      id: "amount",
      header: "Amount",
      accessorKey: "amount",
      cell: AmountCell,
      field: "amount",
    },
    {
      id: "adjusted_amount",
      header: "Adjusted Amount",
      accessorKey: "adjusted_amount",
      cell: AmountCell,
      field: "amount",
    },
    {
      id: "billing_date",
      header: "Billing Date",
      accessorKey: "billing_date",
      sortable: true,
      cell: DateCell,
    },
    {
      id: "due_date",
      header: "Due By",
      accessorKey: "due_date",
      sortable: true,
      cell: DateCell,
    },
  ];

  const defaultFilters = {
    job: { _eq: jobId },
    status: { _neq: "archived" },
  };


  return (
    <>

      <PermissionGate rule="create:SC,AM" collection="billables">
        <HeaderPortal>
          <CreateItemButton disabled={!config} href>
            Billable
          </CreateItemButton>
        </HeaderPortal>
      </PermissionGate>

      <List
        title="Billables"
        storageKey={jobId}
        endPoint="billables"
        filters={defaultFilters}
        columns={columns}
        meta={{ fields }}
        href={(item) => `/work/billables/${item.id}`}
        sortby="billing_date"
        renderFilters={BillableFilters}
      />
    </>
  );
}
